import { Component, inject } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { SharedModule } from "../../../../shared/shared.module";
import { DefinitionFormComponent } from "../../../../shared/forms/definition-form/definition-form/definition-form.component";

interface EditDefinitionModalData {
  name: string;
  categories: string[]
}

@Component({
  selector: "app-edit-definition",
  templateUrl: "./edit-definition.component.html",
  imports: [SharedModule, DefinitionFormComponent],
})
export class EditDefinitionDialogComponent {
  readonly #modal = inject(NzModalRef);
  readonly nzModalData: EditDefinitionModalData = inject(NZ_MODAL_DATA);

  get definitionName(): string {
    return this.nzModalData.name;
  }

  get categoryList(): string[] {
    return this.nzModalData.categories
  }

  onCancel = () => this.#modal.destroy();

  onSubmitSuccess = () => this.#modal.destroy(true);
}
